import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-mobiltelefon',
    templateUrl: './input-field.component.html'
} )
export class MobileNumberComponent extends AbstractFieldComponent<string> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.mobileNumber' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.mobileNumber = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.mobileNumber;
    }
}
